import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {FC, useEffect, useState} from 'react';
import BuildEntry, {iSideNavigation} from "../Framework/Components/Navigation/BuildEntry";
import {ColourSolid} from '../Framework/Data/Enums/LayoutEnums';
import {useClientDashboard} from "../Api/ClientEndpoints";
import {faLifeRing, faHome, faEnvelope, faMessages, faPaperPlane, faGear, faTruckFast, faCreditCard} from "@fortawesome/pro-light-svg-icons";
import {useLayout} from "../Framework/Providers/LayoutProvider";
import UserMenu from "./UserMenu";
import Pill from "../Framework/Components/Pills/Pill";

const Navigation: FC<iSideNavigation> = (props) => {
	const dashboard = useClientDashboard();

	const { toggleSidebar } = useLayout();

	const [ unreadMail, setUnreadMail] = useState<number>(0);
	const [ unreadMessages, setUnreadMessages] = useState<number>(0);

	useEffect(() => {
		if(dashboard?.data) {
			setUnreadMail(dashboard?.data?.counts.mailItems.unread);
			setUnreadMessages(dashboard?.data?.counts.messages.unread);
		}
	}, [dashboard]);

	return (
		<>
			<nav className={`side-navigation dynamic-side-navigation ${props.isBranded ? 'branded' : ''}`}>
				<div className={'navigation-group hide-sm mb-lg'}>
					{process.env.NODE_ENV !== 'production' && (
						<Pill content={process.env.REACT_APP_ENV_LABEL} colour={ColourSolid.Alert} />
					)}

					{props.showLogo && (
						<div className={'navigation-group'}>
							<div className={'side-navigation-logo-container'} onClick={() => toggleSidebar()}>
								<span className='logo-emblem' />
							</div>
						</div>
					)}
				</div>

				<div className={'navigation-group'}>
					<BuildEntry title={'Overview'} url={'/overview'} icon={<FontAwesomeIcon icon={faHome} fixedWidth={true} />} />
					<BuildEntry title={'Mailboxes'} url={'/mail/inbox'} icon={<FontAwesomeIcon icon={faEnvelope} fixedWidth={true} />} badgeCount={unreadMail} />
					<BuildEntry title={'Message Centre'} url={'/message-centre'} icon={<FontAwesomeIcon icon={faMessages} fixedWidth={true} />} badgeCount={unreadMessages}  />
					<BuildEntry title={'Send Mail'} url={'/send'} icon={<FontAwesomeIcon icon={faPaperPlane} fixedWidth={true} />} />
					<BuildEntry title={'Shipping Calculator'} url={'/shipping-calculator'} icon={<FontAwesomeIcon icon={faTruckFast} fixedWidth={true} />} />
				</div>

				<div className={'navigation-group hide-sm mt-a pb-xs'}>
					<BuildEntry title={'Payment'} url={'/settings/payment'} icon={<FontAwesomeIcon icon={faCreditCard} fixedWidth={true} />} />
					<BuildEntry title={'Settings'} url={'/settings'} icon={<FontAwesomeIcon icon={faGear} fixedWidth={true} />} />
					<BuildEntry title={'Support'} url={'/support'} icon={<FontAwesomeIcon icon={faLifeRing} fixedWidth={true} />} />
					<UserMenu />
				</div>
			</nav>
		</>
	);
};

export default Navigation;
